module.exports = __webpack_public_path__ + "img/video-y-fotografia-aerea_poster.2ee3d4a9.jpg";